export default function IconMore () {
  return (
    <svg width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3951_25690)">
        <path
          d="M1.0866 4.98144L3.59199 1.88551C4.00796 1.3715 4.79184 1.3715 5.20781 1.88551L7.71321 4.98144C8.15315 5.52507 7.76623 6.33593 7.06688 6.33593L1.73292 6.33593C1.03357 6.33593 0.646654 5.52507 1.0866 4.98144Z"
          fill="#21A038"/>
      </g>
      <defs>
        <clipPath id="clip0_3951_25690">
          <rect width="8" height="8" fill="white" transform="matrix(-1 0 0 1 8.3999 0)"/>
        </clipPath>
      </defs>
    </svg>
  )
}
